var _defs, _rect, _g, _rect2, _circle, _g2, _g3, _g4, _rect3, _rect4, _circle2, _circle3, _g5, _g6, _polygon, _g7, _path, _path2, _g8, _path3, _path4, _polygon2, _g9, _path5, _path6, _circle4, _path7, _g10, _path8, _path9, _g11, _g12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUiDesign25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_0059_ui_design",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    "data-imageid": "ui-design-25",
    imageName: "UI Design",
    className: "illustrations_image",
    style: {
      width: 166
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1_ui-design-25{fill:#fff;}.cls-2_ui-design-25{opacity:.63;}.cls-2_ui-design-25,.cls-3_ui-design-25,.cls-4_ui-design-25,.cls-5_ui-design-25,.cls-6_ui-design-25,.cls-7_ui-design-25,.cls-8_ui-design-25,.cls-9_ui-design-25,.cls-10_ui-design-25,.cls-11_ui-design-25{fill:none;}.cls-3_ui-design-25{opacity:.19;}.cls-12_ui-design-25{fill:#f4a28c;}.cls-4_ui-design-25{opacity:.43;}.cls-5_ui-design-25{opacity:.46;}.cls-13_ui-design-25{fill:#a5a5a5;}.cls-6_ui-design-25{opacity:.02;}.cls-7_ui-design-25{opacity:.56;}.cls-14_ui-design-25{fill:#e6e6e6;}.cls-8_ui-design-25{opacity:.24;}.cls-9_ui-design-25{opacity:.08;}.cls-15_ui-design-25{fill:#24285b;}.cls-16_ui-design-25{fill:#000001;}.cls-10_ui-design-25{opacity:.06;}.cls-11_ui-design-25{opacity:.15;}.cls-17_ui-design-25{fill:#ffd200;}.cls-18_ui-design-25{fill:#68e1fd;}"))), /*#__PURE__*/React.createElement("g", {
    id: "sc3_ui-design-25"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14_ui-design-25",
    x: 56.54,
    y: 38.28,
    width: 219.58,
    height: 293.88
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9_ui-design-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16_ui-design-25",
    d: "m241.21,213.36s-11.27-2.92-14.12,5.07c-2.85,7.99-28.98-2.42-32.13,21.3-1.75,13.22-26.86,37.03-59.53,44.29-32.67,7.26-34.85,48.16-34.85,48.16h88.75l58.95-86.32-7.08-32.49Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_ui-design-25",
    x: 81.15,
    y: 105.16,
    width: 63.72,
    height: 87.36
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1_ui-design-25",
    cx: 113.03,
    cy: 125.65,
    r: 8.82
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7_ui-design-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1_ui-design-25",
    x: 95.36,
    y: 145.58,
    width: 36.44,
    height: 7.21
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3_ui-design-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1_ui-design-25",
    x: 95.36,
    y: 161.91,
    width: 36.44,
    height: 7.21
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5_ui-design-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1_ui-design-25",
    x: 166.33,
    y: 105.16,
    width: 91.07,
    height: 53.96
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1_ui-design-25",
    x: 166.33,
    y: 174.53,
    width: 91.07,
    height: 17.99
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_ui-design-25",
    x: 230.95,
    y: 174.53,
    width: 26.44,
    height: 17.99
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18_ui-design-25 targetColor",
    cx: 79.2,
    cy: 59.01,
    r: 6.45,
    style: {
      fill: "rgb(34, 197, 94)"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15_ui-design-25",
    cx: 97.76,
    cy: 59.01,
    r: 6.45
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1_ui-design-25",
    cx: 115.4,
    cy: 59.01,
    r: 6.45
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "sc2_ui-design-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14_ui-design-25",
    x: 373.89,
    y: 250.92,
    width: 105.22,
    height: 52.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13_ui-design-25",
    cx: 399.78,
    cy: 277.33,
    r: 14.36
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9_ui-design-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16_ui-design-25",
    d: "m390.84,279.55s27.42,3.24,32.91,24.19h-18.6l-14.31-24.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8_ui-design-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16_ui-design-25",
    x: 425.05,
    y: 268.19,
    width: 35.24,
    height: 6.4
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10_ui-design-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16_ui-design-25",
    x: 425.05,
    y: 280.07,
    width: 35.24,
    height: 6.4
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "sd_ui-design-25",
    className: "cls-6_ui-design-25"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16_ui-design-25",
    cx: 261.2,
    cy: 434.6,
    rx: 175.68,
    ry: 27.13
  }))), /*#__PURE__*/React.createElement("g", {
    id: "person_ui-design-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18_ui-design-25 targetColor",
    d: "m234.37,248.88s-76.85-8.14-73.95,32.51c2.9,40.66,45.98,127.29,45.98,127.29h94.38s71.63-109.87,36.78-145.2c-34.85-35.33-42.79-5.01-103.19-14.6Z",
    style: {
      fill: "rgb(34, 197, 94)"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15_ui-design-25",
    points: "206.26 421.9 263.72 437.4 314.67 411.53 322.42 397.74 271.05 397.74 189.32 397.74 206.26 421.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18_ui-design-25 targetColor",
    d: "m197.31,292.96c7.19-24.08-6.4-50.37-32.12-31.11-17.63,13.2-38.54,55.31-39.62,94.27-2.5,89.57,107.37-6.79,121.02-58.08l-13.52-7.99s-22.78,42.96-47.61,52.27c-17.91,6.71,1.23-13.8,11.86-49.37Z",
    style: {
      fill: "rgb(34, 197, 94)"
    }
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5_ui-design-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1_ui-design-25",
    d: "m197.31,292.96c7.19-24.08-6.4-50.37-32.12-31.11-17.63,13.2-38.54,55.31-39.62,94.27-2.5,89.57,107.37-6.79,121.02-58.08l-13.52-7.99s-22.78,42.96-47.61,52.27c-17.91,6.71,1.23-13.8,11.86-49.37Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1_ui-design-25",
    d: "m234.37,248.88s-11.82,18.6-.24,25.26c11.59,6.66,15.3-.94,15.3-.94,0,0,8.64,10.18,16.35,2.29,7.71-7.9,6.64-23.61-1.24-30.86s-30.18,4.26-30.18,4.26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12_ui-design-25",
    d: "m237.06,249.49c.5,3.43.92,6.87,1.03,10.34.15,4.76,1.68,11.82,9.18,13.21,11.57,2.14,14.65-16.16,14.65-16.16,0,0,7.29-17.15-5.24-19.5-11.28-2.12-21.92-3.63-19.61,12.11Z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9_ui-design-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16_ui-design-25",
    d: "m281.68,275.3s-7.18,15.07,10.97,45.98c10.39,17.69-21.61,47.22-21.61,47.22l-79.61,7.97,14.96,32.23h94.38s41.47-67.46,44.67-102.18c3.2-34.72-63.78-31.21-63.78-31.21Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12_ui-design-25",
    d: "m261.2,257.62s.66-5.56,5.51-5.32c4.85.24,2.94,10.62-5.51,5.32Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12_ui-design-25",
    d: "m239.86,254.53s1.7-5.33-2.81-7.13c-4.51-1.79-7.08,8.45,2.81,7.13Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17_ui-design-25",
    points: "210.02 392.84 203.36 332.16 305.24 332.16 295.07 395.94 296.52 404.11 208.93 404.81 210.02 392.84"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18_ui-design-25 targetColor",
    d: "m251.02,421.9s19.34,6.76,12.7,15.5c-6.64,8.74-17.14-5.78-17.14-5.78l4.44-9.72Z",
    style: {
      fill: "rgb(34, 197, 94)"
    }
  }), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9_ui-design-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16_ui-design-25",
    d: "m305.24,332.16l-20.2,26.67c-11.79,15.56-27.71,27.51-45.94,34.47l-30.16,11.51,80.78-.64,6.82-.05-1.45-8.17,10.16-63.78Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15_ui-design-25",
    d: "m237.06,249.49s-18.75-2.69-10.37-16.48c8.38-13.79,10.24-3.45,14.2-14.14,3.96-10.69,7.52-12.75,13.33-8.18,5.81,4.56.18,14.12,8.96,11.44,8.78-2.68,14.77-5.2,16.44,2.08,1.67,7.27.04,10.75-5.65,13.25-5.69,2.5,3.22,12.28-10.99,16.28-14.21,3.99-21.6-11.53-21.6-11.53l-4.32,7.3Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15_ui-design-25",
    d: "m251.61,418.52s-78.14-39.89-84.8-18.67c-6.66,21.22,47.19,33.56,81.95,34.83l2.85-16.17Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1_ui-design-25",
    cx: 255.3,
    cy: 364.85,
    r: 8.73
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15_ui-design-25",
    d: "m270.6,421.65s62.32-61.75,75.11-43.55c12.79,18.2-34.76,46.31-67.49,58.09l-7.63-14.53Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18_ui-design-25 targetColor",
    d: "m273.04,426.3s-18.46,16.45-7.77,21.29c10.69,4.84,12.96-11.41,12.96-11.41l-5.19-9.88Z",
    style: {
      fill: "rgb(34, 197, 94)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18_ui-design-25 targetColor",
    d: "m281.68,275.3c-1.44-14.45,9.06-27.33,23.49-28.88,14.09-1.52,32.61-.58,49.07,9.74,31.94,20.02,67.28,35.99,58.56,72.29-8.71,36.3-72.12,51.53-72.12,51.53l-8.45-13.78s55.88-18.88,45.72-48.4c-9.16-26.61-90.26,17.84-96.28-42.5Z",
    style: {
      fill: "rgb(34, 197, 94)"
    }
  }), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5_ui-design-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1_ui-design-25",
    d: "m281.68,275.3c-1.44-14.45,9.06-27.33,23.49-28.88,14.09-1.52,32.61-.58,49.07,9.74,31.94,20.02,67.28,35.99,58.56,72.29-8.71,36.3-72.12,51.53-72.12,51.53l-8.45-13.78s55.88-18.88,45.72-48.4c-9.16-26.61-90.26,17.84-96.28-42.5Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12_ui-design-25",
    d: "m333.64,368.49s-17.63,11.92-11.22,15.2c6.41,3.28,17.21-5.44,17.21-5.44l-5.99-9.76Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12_ui-design-25",
    d: "m235.43,291.45s6.31-15.48,14.96-14.23c8.65,1.25-4.85,20.2-4.85,20.2l-10.11-5.97Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "sc1_ui-design-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14_ui-design-25",
    x: 305.24,
    y: 90.38,
    width: 147.62,
    height: 137.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_ui-design-25",
    x: 321.77,
    y: 107.2,
    width: 49.29,
    height: 45.59
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4_ui-design-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_ui-design-25",
    x: 321.77,
    y: 165.52,
    width: 49.29,
    height: 45.59
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11_ui-design-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_ui-design-25",
    x: 387.2,
    y: 165.52,
    width: 49.29,
    height: 45.59
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2_ui-design-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1_ui-design-25",
    points: "325.45 144.21 335.08 129.34 346.41 142.6 357.25 123.56 367.38 144.49 367.38 149.76 325.45 149.76 325.45 144.21"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1_ui-design-25",
    cx: 346.02,
    cy: 121.76,
    r: 4.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13_ui-design-25",
    x: 387.59,
    y: 107.2,
    width: 49.29,
    height: 45.59
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2_ui-design-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1_ui-design-25",
    points: "391.27 144.21 400.9 129.34 412.24 142.6 423.07 123.56 433.2 144.49 433.2 149.76 391.27 149.76 391.27 144.21"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1_ui-design-25",
    cx: 411.84,
    cy: 121.76,
    r: 4.93
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "code_ui-design-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17_ui-design-25",
    x: 20.89,
    y: 223.64,
    width: 95.04,
    height: 54.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15_ui-design-25",
    d: "m55.64,264.34c-.47,0-.95-.15-1.35-.47l-14.1-11.15c-.52-.41-.83-1.04-.83-1.7,0-.66.3-1.29.81-1.71l14.1-11.35c.94-.76,2.31-.61,3.06.33.75.94.61,2.31-.33,3.06l-11.98,9.64,11.96,9.46c.94.75,1.1,2.12.36,3.06-.43.54-1.07.83-1.71.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15_ui-design-25",
    d: "m81.18,264.34c-.64,0-1.28-.28-1.71-.83-.75-.94-.59-2.31.36-3.06l11.96-9.46-11.98-9.64c-.94-.75-1.08-2.12-.33-3.06.76-.94,2.13-1.08,3.06-.33l14.11,11.35c.52.42.82,1.04.81,1.71,0,.66-.31,1.29-.83,1.7l-14.11,11.15c-.4.32-.87.47-1.35.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15_ui-design-25",
    d: "m62.49,264.34c-.3,0-.61-.06-.9-.2-1.09-.5-1.58-1.79-1.08-2.89l10.28-22.5c.5-1.09,1.79-1.58,2.89-1.08,1.09.5,1.58,1.79,1.08,2.89l-10.28,22.5c-.37.8-1.16,1.27-1.98,1.27Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiDesign25);
export default __webpack_public_path__ + "static/media/ui-design-25.e95bd65ae8a180ea9ab5b7e174ff14b6.svg";
export { ForwardRef as ReactComponent };